
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { isAuthenticated } from '@/utils/auth';
import { getCurrentUser } from '@/utils/auth';
import { safeUserRole } from '@/utils/roleUtils';
import { Button } from '@/components/ui/button';

const NotFound = () => {
  const navigate = useNavigate();
  const [redirectUrl, setRedirectUrl] = useState<string>('/');
  
  useEffect(() => {
    // Determine where to redirect based on user role
    const determineRedirect = () => {
      if (isAuthenticated()) {
        const currentUser = getCurrentUser();
        const userRole = safeUserRole(currentUser?.role);
        
        if (userRole === 'masterAdmin') {
          setRedirectUrl('/master/dashboard');
        } else if (userRole === 'superadmin') {
          setRedirectUrl('/super-admin/dashboard');
        } else if (userRole === 'admin') {
          setRedirectUrl('/admin/dashboard');
        } else if (userRole === 'business') {
          setRedirectUrl('/business/dashboard');
        } else {
          setRedirectUrl('/user/dashboard');
        }
      } else {
        setRedirectUrl('/login');
      }
    };
    
    determineRedirect();
  }, []);
  
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-4 text-center">
      <h1 className="text-9xl font-bold text-blue-600">404</h1>
      <h2 className="mt-6 text-3xl font-bold tracking-tight">Page not found</h2>
      <p className="mt-4 text-lg text-gray-600 max-w-md">
        Sorry, we couldn't find the page you're looking for. It might have been moved or deleted.
      </p>
      <div className="mt-10 space-y-4 w-full max-w-xs">
        <Button asChild className="w-full">
          <Link to={redirectUrl}>Go to Dashboard</Link>
        </Button>
        <Button variant="outline" asChild className="w-full" onClick={() => navigate(-1)}>
          <span>Go Back</span>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
